<template>
    <div>
        {{ $t('delete_confirmation.please_type_delete') }}
        <div class="form-group">
            <input type="text" class="form-control" id="typed" :placeholder="$t('delete_confirmation.type_delete_here')"  v-model="typed">
        </div>
        <button class="btn btn-danger" :disabled="!deleteButtonEnabled" :class="{'disabled': !deleteButtonEnabled}" @click="$emit('clicked', true)">
            {{ $t('actions.delete') }}
        </button>
    </div>
</template>

<script>
export default {
    name: "DeleteConfirmation",
    data: () => ({
        typed: ''
    }),
    computed: {
        deleteButtonEnabled() {
            return this.typed === 'DELETE';
        }
    }
}
</script>

<style scoped>

</style>
